export enum ActionTypes {
  FETCH_LOGGED_IN_USER = 'FETCH_LOGGED_IN_USER',
  LOGGED_IN_USER_FETCH_SUCCEDED = 'LOGGED_IN_USER_FETCH_SUCCEDED',
  LOGGED_IN_USER_FETCH_FAILED = 'LOGGED_IN_USER_FETCH_FAILED',
  UPDATE_UI_USER_PREFERENCES = 'UPDATE_UI_USER_PREFERENCES',
}
